import { render, staticRenderFns } from "./qa3.vue?vue&type=template&id=953ae85e&"
import script from "./qa3.vue?vue&type=script&lang=js&"
export * from "./qa3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/nsdua/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('953ae85e')) {
      api.createRecord('953ae85e', component.options)
    } else {
      api.reload('953ae85e', component.options)
    }
    module.hot.accept("./qa3.vue?vue&type=template&id=953ae85e&", function () {
      api.rerender('953ae85e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/page/_home/qa3.vue"
export default component.exports